import React, { ComponentProps } from 'react';

import { HeaderNav } from '../../header-nav';
import { useFullLayoutContext } from '../context';

export function Header(props: ComponentProps<typeof HeaderNav>) {
  const { onBrainfishNativeClick, ...rest } = props;
  const ctx = useFullLayoutContext();
  if (!ctx) return null;

  const handleNativeClick = () => {
    ctx.toggleRightSidebar();
    onBrainfishNativeClick?.();
  };

  return (
    <HeaderNav
      {...rest}
      showSidebarToggle={!ctx.disableLeftSideNav}
      isSideNavOpen={ctx.isSideNavOpen}
      onSideNavigationToggle={ctx.toggleSidebar}
      onBrainfishNativeClick={handleNativeClick}
      sidebarToggleRef={ctx.sidebarToggleRef as React.Ref<HTMLButtonElement>}
    />
  );
}
Header.displayName = 'FullLayout.Header';
